export const ensureValidArray = (value: any, defaultValue = null) => {
	if (Array.isArray(value) && value.length > 0) {
		return value;
	}
	return defaultValue;
};
